
import React from 'react';
import './trend-badge.css';

function TrendBadge({ trend, className = '' }) {
  // Handle null/undefined values
  if (!trend || trend === 'N/A') {
    return (
      <span className={`trend-badge trend-na ${className}`}>
        N/A
      </span>
    );
  }

  // Normalize trend value
  const normalizedTrend = trend.toLowerCase();

  return (
    <span className={`trend-badge trend-${normalizedTrend} ${className}`}>
      {trend.charAt(0).toUpperCase() + trend.slice(1).toLowerCase()}
    </span>
  );
}

export default TrendBadge;
